import { gql } from '@apollo/client';

export const DISCOVER_SSO_PROVIDER = gql`
  query DiscoverSSOProvider($email: String!) {
    discoverSSOProvider(email: $email) {
      hasSso
      loginMethod
      cognitoAuthorizationEndpoint
      cognitoClientId
      identityProvider
      scope
    }
  }
`;
